import React from 'react';

export const LoadingPage = () => {
    return (
        <></>
    );
};
